import config from '../config.js'

//ACCOUNT 
export const ACCOUNT_FETCH_URI = 'com.magenta.account.fetch'

//AGENTS
export const AGENT_FIND_URI = 'com.magenta.agent.find'
export const AGENT_CREATE_URI = 'com.magenta.agent.create'
export const AGENT_DELETE_URI = 'com.magenta.agent.delete'
export const AGENT_FETCH_URI = 'com.magenta.agent.fetch'
export const AGENT_PATCH_URI = 'com.magenta.agent.patch'

//GEOCODING
export const GEOCODING_REVERSE_URI = 'com.magenta.geocoding.reverse'

//GEOFENCE
export const GEOFENCE_FIND_URI = 'com.magenta.geofence.find'
export const GEOFENCE_FETCH_URI = 'com.magenta.geofence.fetch'
export const GEOFENCE_CREATE_URI = 'com.magenta.geofence.create'
export const GEOFENCE_UPDATE_URI = 'com.magenta.geofence.patch'
export const GEOFENCE_DELETE_URI = 'com.magenta.geofence.delete'
export const GEOFENCE_MIN_RADIUS = 50
export const GEOFENCE_MAX_RADIUS = 5000000

//GLOBAL
export const GOOGLE_PLAY_APP_URL = 'https://play.google.com/store/apps/details?id=com.lojack.strixflotas'
export const APPLE_STORE_APP_URL = 'https://apps.apple.com/ar/app/strix-flotas/id1562739783'
export const RACE_TIMEOUT = 30000
export const MIN_SPEED_THING_VEHICLE = 7
export const MIN_SPEED_THING_FLEX = 3
export const MIN_PAGINATION_VALUE = 1000
export const CLICKGO_MAX_BUNDLE_VALUE = 100
export const REFRESH_MS = 500
export const SNACKBAR_TIMEOUT = 3000

//NOTIFICATIONS
export const NOTIFICATION_CREATE_URI = 'com.magenta.notification.create' 
export const NOTIFICATION_DELETE_URI = 'com.magenta.notification.delete' 
export const NOTIFICATION_FIND_URI = 'com.magenta.notification.find'
export const NOTIFICATION_FETCH_URI = 'com.magenta.notification.fetch'
export const NOTIFICATION_LIMIT_PAGINATION = 20
export const NOTIFICATION_STATE_URI = 'com.magenta.notification.state'
export const NOTIFICATION_UPDATE_URI = 'com.magenta.notification.update' 
export const NOTIFICATION_MARKER_TIME = 10000

//PERSON
export const PERSON_FETCH_URI = 'com.magenta.person.fetch'
export const PERSON_FIND_URI = 'com.magenta.person.find'
export const PERSON_LIST_URI = 'com.magenta.person.list'
export const PERSON_CREATE_URI = 'com.magenta.person.create'
export const PERSON_UPDATE_URI = 'com.magenta.person.update'
export const PERSON_DELETE_URI = 'com.magenta.person.delete'
export const PERSON_ADD_ROL_URI = 'com.magenta.person.add_role'
export const PERSON_UPDATE_ROL_URI = 'com.magenta.person.update_role'
export const PERSON_DELETE_ROL_URI = 'com.magenta.person.remove_role'

//TERMS_AND_CONDITIONS
export const TERMS_CONDITIONS_ACCEPT_URI = 'com.magenta.terms_conditions.accept'
export const TERMS_CONDITIONS_FETCH_URI = 'com.magenta.terms_conditions.fetch'
export const TERMS_CONDITIONS_FETCH_LAST_VERSION_URI = 'com.magenta.terms_conditions.fetch_last_version'
export const TERMS_CONDITIONS_PUBLIC_URL_AR = config.tycPublicUrlAR()
export const TERMS_CONDITIONS_PUBLIC_URL_CL = config.tycPublicUrlCL()
export const TERMS_CONDITIONS_PUBLIC_URL_UY = config.tycPublicUrlUY()

//MAINTENANCE SERVICE
export const MAINTENANCE_SERVICE_URI = 'com.magenta.connected_accounts.get_link'

//USER
//Returns a thing list, according to the user's privileges.
export const USER_UPDATE_GROUPS_URI = 'com.magenta.user.update_groups'

//THINGS
export const THING_FIND_URI = 'com.magenta.thing.find'
export const THING_FETCH_URI = 'com.magenta.thing.fetch'
export const THING_TRAIL_URI = 'com.magenta.thing.trail_locations'
export const THING_TRAIL_SUMMARY_URI = 'com.magenta.thing.trail_summary'
export const THING_UPDATE_URI = 'com.magenta.thing.update'
export const THING_PATCH_URI = 'com.magenta.thing.patch'
export const THING_HEALTH_CERTIFICATE_URI = 'com.magenta.health_certificate.generate'

//CONTACTS
export const THING_CONTACTS_FETCH_URI = 'com.magenta.thing_contacts.fetch'
export const THING_CONTACTS_CREATE_URI = 'com.magenta.thing_contacts.create'
export const THING_CONTACTS_SET_URI = 'com.magenta.thing_contacts.set'
export const THING_CONTACTS_THING_LIST = 'com.magenta.thing_contacts.thing_list'
export const THING_CONTACTS_UPDATE_URI = 'com.magenta.thing_contacts.update'
export const THING_CONTACTS_ERASE_URI = 'com.magenta.thing_contacts.erase'

//TAGS
export const TAG_CREATE_URI = 'com.magenta.tag.create'
export const TAG_LIST_URI = 'com.magenta.tag.list'
export const TAG_FETCH_URI = 'com.magenta.tag.fetch'
export const TAG_FIND_URI = 'com.magenta.tag.find'
export const TAG_ENTITIES_FIND_URI = 'com.magenta.tag.entities.find'
export const TAG_ENTITIES_ADD_URI = 'com.magenta.tag.entities.add'
export const TAG_THING_SET_URI = 'com.magenta.tag.thing.set'
export const TAG_AGENT_SET_URI = 'com.magenta.tag.agent.set'
export const TAG_PERSON_SET_URI = 'com.magenta.tag.person.set'
export const TAG_DELETE_URI = 'com.magenta.tag.erase'
export const TAG_UPDATE_URI = 'com.magenta.tag.update'
export const TAG_RACE_TIMEOUT = 300000

//POINTSOFINTEREST
export const INTEREST_POINT_CREATE_URI = 'com.magenta.interest_point.create'
export const INTEREST_POINT_ERASE_URI = 'com.magenta.interest_point.erase'
export const INTEREST_POINT_UPDATE_URI = 'com.magenta.interest_point.update'
export const INTEREST_POINT_FIND_URI = 'com.magenta.interest_point.find'
export const INTEREST_POINT_FETCH_URI = 'com.magenta.interest_point.fetch'

//ALIAS
export const THING_ALIAS_FIND_URI = 'com.magenta.thing.alias.find'
export const THING_ALIAS_FETCH_URI = 'com.magenta.thing.alias.fetch'

// DEVICE
export const DEVICE_CREATE_URI = 'com.magenta.device.create'
export const DEVICE_DELETE_URI = 'com.magenta.device.delete'
export const DEVICE_FIND_URI = 'com.magenta.device.find'
export const DEVICE_LOGOUT_URI = 'com.magenta.device.logout'
export const DEVICE_DELETED_URI = 'com.magenta.device.deleted'

// SERVER PING
export const SERVER_PING_URI = 'bondy.ping'

//WAMP
export const WAMP_REALM_URI = config.wampRealmUri()
export const SECURE_WS_URI = config.apiWampUrl()